import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { SearchableAlphabets, SearchableAlphabetsPa } from '../core/constants';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: 'my-auth-token',
  }),
};
@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  recordsPerPage: number = 48;
  constructor(private http: HttpClient) { }

  getBaniList(lang: string): Observable<any> {
    const headers = new HttpHeaders().set('api-key', environment.apiKey);

    const params = {
      'api-version': '2020-06-30',
      '$top': '200',
      '$filter': `BaniLanguage eq '${lang}' and IsIntroduction eq 1`,
      '$orderby': 'IsPublished, BaniName desc'
    };

    return this.http.get(environment.apiUrl, { headers, params });
  }
  getSectionsForBani(lang: string, baniCode: string): Observable<any> {
    const headers = new HttpHeaders().set('api-key', environment.apiKey);

    const params = {
      'api-version': `${environment.apiVersion}`,
      '$top': '200',
      '$filter': `BaniLanguage eq '${lang}' and BaniCode eq '${baniCode}' and (SubSectionSequence eq 1 or SectionSequence eq 0)`,
      '$orderby': 'SectionSequence asc'
    };
    
    return this.http.get(environment.apiLandingUrl, { headers, params });
  }
  getSubSections(lang: string, baniCode: string, sectionCode: string): Observable<any> {
    const url = `${environment.apiWordInstance}`;
    const params = {
      'api-version': `${environment.apiVersion}`,
      '$top': '200',
      '$filter': `BaniLanguage eq '${lang}' and BaniCode eq '${baniCode}' and SectionName eq '${sectionCode}'`,
      '$orderby': 'SubSectionSequence asc'
    };
    const headers = new HttpHeaders().set('api-key', environment.apiKey);
  
    return this.http.get(url, { headers, params });
  }
  
  getBaniTestingResult(lang: string, baniCodeNav: string, SecSeqNav: string, SubSeqSecNav: string): Observable<any> {
    const url = `${environment.baniUrl}/api/word/GetAdminBaniSubSectionDetailTest`;
    const token = `${environment.apiAuthorizationtoken}`;
    const params = new HttpParams()
      .set('language', lang)
      .set('baniCodeNav', baniCodeNav)
      .set('SecSeqNav', SecSeqNav)
      .set('SubSeqSecNav', SubSeqSecNav);

    const headers = new HttpHeaders()
      .set('Authorization', `Basic ${token}`);

      return this.http.get(url, { headers, params });
  }

 // Method to make the HTTP post request with authorization
 postBaniTestingResult(wordsArray: any): Observable<any> {
  // Prepare the authorization header
  const theUrl = `${environment.baniUrl}/api/word/AdminBaniTestResult`;
  const token = `${environment.apiAuthorizationtoken}`; 
  const headers = new HttpHeaders().set('Authorization', `Basic ${token}`);

  // Send the wordsArray in the body of the POST request with authorization headers
  return this.http.post<any>(theUrl,  wordsArray , { headers });
}

  fetchBaniIntroductionData(baniId: number) {
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';

    return this.http.get<any>(
      `${environment.apiUrl}?api-version=${environment.apiVersion}&search=&$select=BaniId,BaniLanguage,BaniName,BaniCode,Introduction,HistoricalDimension,MusicalDimension,SignificantTerms,CulturalDimension,MetaTagTitle,MetaTagKeyWords,MetaTagDescription,TileImageURL&$count=true&$filter=BaniLanguage eq '${baniLanguageString}' and BaniId eq ${baniId}`
    );
  }

  fetchBaniContents(baniCode: string | null) {
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';

    let subSection = baniLanguage && baniLanguage === 'en' ? 1 : 2;

    return this.http.get<any>(
      `${environment.apiLandingUrl}?api-version=${environment.apiVersion}&$orderby=SectionSequence asc&$select=BaniId,BaniName,BaniCode,SectionName,SectionSequence,subsectionContent,MetaTagTitle,MetaTagKeyWords,MetaTagDescription&$filter=BaniLanguage eq '${baniLanguageString}' and BaniCode eq '${baniCode}' and SubSectionSequence eq ${subSection}`
    );
  }

  fetchBaniSubDetails(baniCode: string | null, sectionSequence: number | null,subSectionSequence: number | null) {
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';

    let subSection = baniLanguage && baniLanguage === 'en' ? 1 : 2;

    return this.http.get<any>(
      `${environment.apiBaniSubsectionUrl}?api-version=${environment.apiVersionPreview}&search=*&$count=true&$filter=BaniLanguage eq '${baniLanguageString}' and BaniCode eq '${baniCode}'`,{params: {section:`${sectionSequence}`, sub:`${subSectionSequence}`}}
    );
  }

  /**
   * Called from the search page
   * @returns array of objects
   */
  fetchAllSearchAbleData(
    searchedTerm: string,
    alphabeticSort: string,
    dateSort: string,
    currentPage: number,
    searchType: string
  ) {
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';
    let sortCriteria = '';
    let type = '';
    if(searchType?.trim()){
      type=`&searchType=${searchType?.trim()}`
    }
    let skipNumber = currentPage ? currentPage * this.recordsPerPage : 0;
    if (alphabeticSort || dateSort) {
      sortCriteria = alphabeticSort
        ? `&$orderby=BaniSequence ${alphabeticSort}`
        : `&$orderby=PublishedDate ${dateSort}`;
    }
    return this.http.get<any>(
      `${environment.apiUrl}?api-version=${environment.apiVersionPreview}${sortCriteria}${type}&search=${searchedTerm}&$select=BaniId,BaniName,BaniCode,Introduction,VideoSource,BaniImageURL,BaniVideoURL,MetaTagTitle,MetaTagKeyWords,MetaTagDescription,Search_Details&$top=${this.recordsPerPage}&$skip=${skipNumber}&$count=true&$filter=BaniLanguage eq '${baniLanguageString}' and IsPublished eq true`
    );
  }

  getTags(text: string) {
    return this.http.get<any>(
      `${environment.apiUrl2}?api-version=${environment.apiVersionPreview}&search=${text}`
    )
  }

  fetchWordFromDictionary(word: string,baniCode: string | null) {
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';

    return this.http.get<any>(
      // `${environment.apiDictionary}?api-version=${environment.apiVersion}&search=*&$top=500&searchFields=WordName,Spelling&$filter=BaniLanguage eq '${baniLanguageString}'and (BaniCode eq null or BaniCode eq '${baniCode}' ) and WordName eq '${word}' or WordId eq 0 &$orderby=BaniCode asc`
      `${environment.apiDictionary}?api-version=${environment.apiVersion}&search=*&$top=1000&searchFields=WordName,Spelling&$orderby=BaniCode asc&$filter=search.ismatch('${word}', 'WordName') and BaniLanguage eq '${baniLanguageString}' and (BaniCode eq null or BaniCode eq '${baniCode}' )`
    );
  }

  fetchCarouselItems(): Observable<any> {
    httpOptions.headers = httpOptions.headers.set(
      'api-key',
      environment.apiKey
    );
    return this.http.get(
      `${environment.apiSiteCarousel}?api-version=${environment.apiVersionPreview}&search=*`,
      httpOptions
    );
  }

  fetchBaniDashboardData(baniCode: string | null) {
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';

    return this.http.get<any>(
      `${environment.apiBaniDashboard}?api-version=${environment.apiVersionPreview}&$filter=BaniLanguage eq '${baniLanguageString}' and BaniCode eq '${baniCode}'&$count=true&$search=*`
    );
  }

  fetchFeaturedItems(listType: string): Observable<any> {
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';

    return this.http.get<any>(
      `${environment.apiUrl}?api-version=${environment.apiVersionPreview}&$orderby=BaniSequence&$select=BaniId,BaniName,BaniCode,Introduction,PublishedDate,BaniBroadcastAttribute,VideoSource,BaniImageURL,BaniVideoURL,MetaTagTitle,MetaTagKeyWords,MetaTagDescription&$top=3&$filter=BaniLanguage eq '${baniLanguageString}' and BaniBroadcastAttribute eq '${listType}'`
    );
  }

  fetchRecentItems(): Observable<any> {
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';

    return this.http.get<any>(
      `${environment.apiUrl}?api-version=${environment.apiVersion}&$orderby=PublishedDate desc&$select=BaniId,BaniName,BaniCode,Introduction,PublishedDate,BaniBroadcastAttribute,VideoSource,BaniVideoURL,BaniImageURL,MetaTagTitle,MetaTagKeyWords,MetaTagDescription&$top=3&$filter=BaniLanguage eq '${baniLanguageString}'`
    );
  }

  fetchSignificantTerms(isHandsetPortrait: boolean): Observable<any> {
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';

    let itemsToFetch = isHandsetPortrait ? 3 : 6;

    return this.http.get<any>(
      `${environment.apiWordsUrl}?api-version=${environment.apiVersion}&$top=${itemsToFetch}&$select=WordName,WordDescription&$filter=BaniLanguage eq '${baniLanguageString}'&$orderby=SortOrder`
    );
  }

  fetchSignificantTermsList(
    isHandsetPortrait: boolean,
    activeAlphabetCriteriaIndex: number,
    hashtagSearch: string,
    searchTerm: string
  ) {
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';

    let searchNeeded = '';
    let sa = localStorage.getItem('language') === 'en' ? SearchableAlphabets : SearchableAlphabetsPa
    if (activeAlphabetCriteriaIndex) {
      searchNeeded = `&search=${sa[activeAlphabetCriteriaIndex]}*&searchFields=WordName`;
    } else if (hashtagSearch) {
      searchNeeded = `&search=${hashtagSearch}&searchFields=Attributes`;
    } else if (searchTerm) {
      searchNeeded = `&search=${searchTerm}`;
    }

    return this.http.get<any>(
      `${environment.apiWordsUrl}?api-version=${environment.apiVersion}&$top=1000&$select=WordID,WordName,WordDescription,Attributes${searchNeeded}&$filter=BaniLanguage eq '${baniLanguageString}'`
    );
  }

  fetchSignificantTerm(termName: string | null) {
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';

    return this.http.get<any>(
      `${environment.apiWordsUrl}?api-version=${environment.apiVersion}&$select=WordID,WordName,WordDescription,Attributes&$filter=BaniLanguage eq '${baniLanguageString}' and WordName eq '${termName?.trim()}'`
    );
  }

  fetchBaniFootnotes(baniId: string | null, section: number) {
    return this.http.get<any>(
      `${environment.apiFootnotesUrl}?api-version=${environment.apiVersion}&search=*&$top=200&$filter=SectionId eq '${section}' and BaniId eq '${baniId}'&$count=true`
    );
  }

  fetchTeam() {
    return this.http.get<any>(
      `${environment.apiTeamUrl}?api-version=${environment.apiVersionPreview}&search=*&$orderby=FirstName`
    );
  }

  fetchProjectSikhTeam() {
    return this.http.get<any>(
      `${environment.apiTeamUrl}?api-version=${environment.apiVersionPreview}&search=*`
    );
  }

  contactUs(data: any, a: any): any {
    const token = `${environment.apiAuthorizationtoken}`;  
    const headers = new HttpHeaders()
      .set('Authorization', `Basic ${token}`);

    return this.http.get<any>(
      `${environment.smtpEmailUrl}/api/word/send?fName=${data.firstName}&lName=${data.lastName}&email=${data.emailID}&phone=${data.phone}&type=${a}&message=${data.message}`,{ headers }
      // `${environment.smtpEmailUrl}/mail.php?fName=${data.firstName}&lName=${data.lastName}&email=${data.emailID}&phone=${data.phone}&type=${a}&message=${data.message}`
    );
  }

  createContactUs(payload: any) {
    return this.http.post<any>(
      `${environment.baseUrl}CreateContactUs`, payload
    );
  }

  subscribeLetter(payload: any) {
    // const subscribeOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'application/json',
    //     Authorization: 'my-auth-token',
    //     'Api-key': environment.apiKey
    //   }),
    // };
    return this.http.post<any>(
      `${environment.baseUrl}RegisterForNewBaniReleases`, payload
    );
  }

  //   googleForms(payload: any){
  // //     const sheetid = "1RZ2G_iRbTso8ysYL5mBe-yOodUKciDgZA1RCEwyFVfI"
  // //      const url = 
  // // `https://spreadsheets.google.com/feeds/list/${sheetid}/${sheetno}/public/values?alt=json`;
  //     return this.http.post<any>(
  //       'https://sheet.best/api/sheets/234ef5b3-95a4-417c-9ed9-f2e448e4dffd',{
  //         Timestamp:new Date(),
  //         'First Name': payload.firstName,
  //         'Last Name': payload.lastName,
  //         email: payload.emailID,
  //         phone: payload.phone,
  //         'How Satisfied are you with the new website design?': payload.newDesign
  //       }
  //     )
  //   }

  //   googleScript(payload: any){
  //     return this.http.post<any>('https://script.google.com/macros/s/AKfycbw91AV40yLvX8qgUf5dw941Lm9pt7UQH7dWG7VEItOSragLjFmRJLD_o7CcrWXA1Pt7Kw/exec',JSON.stringify(payload))
  //   }

  dictioanrySearch(searchText : string){
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';
    return this.http.get<any>(
      `${environment.apiDictionary}?api-version=${environment.apiVersion}&search=${searchText}&$count=true&$filter=BaniLanguage eq '${baniLanguageString}'`
    );
  }

  wordInstance(searchText: string){
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';
    return this.http.get<any>(
      `${environment.apiWordInstance}?api-version=${environment.apiVersion}&search=${searchText}, ${searchText}*&$top=200&searchFields=SubSectionContent,SubSectionLiteralTranslation,SubSectionMeaningInterpretive,SubSectionPoeticalDimension,SubSectionCommentary&$filter=BaniLanguage eq '${baniLanguageString}'&$count=true`
    );
  }

}
